import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { GlobalStoreService } from '../../../services/global-store.service';
import { GlobalService } from '../../../services/global.service';
import { Subscription } from 'rxjs';
import { DetectChangeService } from 'src/app/modules/shared/services/detect-change.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoutModalComponent } from '../../modals/logout-modal/logout-modal.component';
import { NavigationEnd, Router } from '@angular/router';
import { Report } from '../../../models/client-master.model';
import { Item } from 'src/app/modules/shared/dropdown/dropdown.models';
import { v4 } from 'uuid';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {

  photoSub: Subscription;
  profileSub: Subscription;
  getCurrentRoute = '';
  reports: Report[] = [];
  reportsItem: Item[] = [];
  routeDetect: Subscription;
  rolesWithSavingsGuideAccess = ['Market Delivery Lead', 'Market Business Lead', 'Management'];

  constructor(
    private globalService: GlobalService,
    private msalService: MsalService,
    private modalService: NgbModal,
    private detectChange: DetectChangeService,
    private router: Router,
    public store: GlobalStoreService) {

      if (this.router.url.includes('help')) {
        this.store.profile= JSON.parse(localStorage.getItem('profile'));
      }


    // if (!this.store.profile) {
    //   this.profileSub = this.globalService.getProfile().subscribe(profile => this.store.profile = {
    //     EmployeeName: profile?.displayName || '',
    //     EmployeeMail: profile?.mail || ''
    //   });
    // }

    // this.retrieveSIDData();
    this.reports = this.store.clientMaster?.Reports;
    this.routeDetect = this.router.events.subscribe(res => {
      if (res instanceof NavigationEnd) {

        this.getCurrentRoute = this.router.url.split('/')[1];
        if (this.router.url.includes('aoa')) {
          this.store.selectedReport = 7;
        }
        else if (this.router.url.includes('status')) {
          this.store.selectedReport = 1;
        }
        else if (this.router.url.includes('performance')) {
          this.store.selectedReport = 3;
        }
        else if (this.router.url.includes('target')) {
          this.store.selectedReport = 8;
        }
        else if (this.router.url.includes('project')) {
          this.store.selectedReport = 9;
        }
        else if (this.router.url.includes('saving')) {
          this.store.selectedReport = 10;
        }
        else if (this.router.url.includes('usage-summary')) {
          this.store.selectedReport = 12;
        }
        else if (this.router.url.includes('usage')) {
          this.store.selectedReport = 11;
        }
        else if (this.router.url.includes('automate')) {
          this.store.selectedReport = 13;
        }
        else {
          this.store.selectedReport = 2;
        }
        if (this.reports) {
          this.reportsItem = this.reports.map((r, i) => ({
            checked: r.ReportId === this.store.selectedReport ?
              true : false, visible: true,
              // (r.ReportId === 8 && this.store.clientMaster.PIT[0].IsPIT === true) ? true :
              // (r.ReportId !== 8) ? true : false,
              name: r.ReportName, id: r.ReportId, uuid: v4(), project: r.ReportName
          }));
        }
      }
    });
  }
  // retrieveSIDData()
  // {
  //     let data = localStorage.getItem('getSID');
  //     if (data === null){
  //       this.globalService.getSID();
  //       localStorage.setItem('getSID', 'true');
  //     }
  // }
  ngOnInit(): void {
    this.photoSub = this.globalService.getProfilePhoto().subscribe(photo => this.store.photo = photo);
  }

  get getReportDescription() {
    if (this.reports) {
      return this.reports.find(k => k.ReportId === this.store.selectedReport)?.ReportDescription;
    }
  }

  getSavingsGuide() {
    this.globalService.getSavingsGuide();
  }

  getUserGuide() {
    this.globalService.getUserGuide();
  }

  ngOnDestroy(): void {
    /* istanbul ignore else*/
    if (this.photoSub) {
      this.photoSub.unsubscribe();
    }

    /* istanbul ignore else*/
    if (this.profileSub) {
      this.profileSub.unsubscribe();
    }

    /* istanbul ignore else*/
    if (this.routeDetect) {
      this.routeDetect.unsubscribe();
    }
  }

  navigateReports(val) {
    this.store.selectedReport = val.item.id;
    switch (val.item.id) {
      case 1:
        this.router.navigateByUrl('/reports/overall-status-report');
        break;
      case 2:
        this.router.navigateByUrl('/reports/delay-report');
        break;
      case 3:
        this.router.navigateByUrl('/reports/client-performance-report');
        break;
      case 7:
        this.router.navigateByUrl('/reports/aoa-effectiveness-report');
        break;
      case 8:
      this.router.navigateByUrl('/reports/pit-target-report');
        break;
      case 9:
      this.router.navigateByUrl('/reports/project-level-report');
        break;
      case 10:
        this.router.navigateByUrl('/reports/actionitem-saving-report');
        break;
      case 11:
        this.router.navigateByUrl('/reports/application-usage-report');
        break;
      case 12:
        this.router.navigateByUrl('/reports/app-usage-summary-report');
        break;
      case 13:
        this.router.navigateByUrl('/reports/automate-user-access-report');
        break;
    }
  }

  logout() {
    const onLogout = () => {
      this.store.loading = true;
      this.globalService.logout().subscribe({
        complete: () => {
          this.store.loading = false;
          this.msalService.logout();
          localStorage.clear();
          sessionStorage.clear();
        }
      });
    };

    const modalRef = this.modalService.open(LogoutModalComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.result.then(result => result === 'Logout' ? onLogout() : null);

    if (this.detectChange.isPendingChanges()) {
      const changes = this.detectChange.getPendingChanges();
      modalRef.componentInstance.changes = changes.filter(i => i.clients.length);
      modalRef.componentInstance.message = 'There are unsaved changes in the below tab(s). Do you still want to logout?';
    } else {
      modalRef.componentInstance.message = 'Are you sure you want to logout?';
    }
  }

  onHelpClick()
  {
    localStorage.setItem('profile', JSON.stringify(this.store.profile));
    const url = this.router.createUrlTree(['/help']);
    window.open(url.toString(), '_blank');
  }
}
